"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiCheckbox = _interopRequireDefault(require("@tencent/spaui-checkbox"));

var _index = require("../utils/index");

var _img_component = _interopRequireDefault(require("./img_component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * 这里需要用类组件，不能用函数组件，因为函数组件不能给予refs，与 popover 搭配使用会报 warnings
 */
var SelectionImgItemComponent =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(SelectionImgItemComponent, _React$PureComponent);

  function SelectionImgItemComponent() {
    _classCallCheck(this, SelectionImgItemComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelectionImgItemComponent).apply(this, arguments));
  }

  _createClass(SelectionImgItemComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$open = _this$props.open,
          open = _this$props$open === void 0 ? false : _this$props$open,
          _this$props$data = _this$props.data,
          data = _this$props$data === void 0 ? {} : _this$props$data,
          titleable = _this$props.titleable,
          _this$props$changeTri = _this$props.changeTriggerEvent,
          changeTriggerEvent = _this$props$changeTri === void 0 ? 'onClick' : _this$props$changeTri,
          customTitle = _this$props.customTitle,
          multiple = _this$props.multiple,
          onMouseOver = _this$props.onMouseOver,
          onMouseOut = _this$props.onMouseOut,
          _this$props$showSelec = _this$props.showSelectionImgItemComponent,
          showSelectionImgItemComponent = _this$props$showSelec === void 0 ? false : _this$props$showSelec,
          _this$props$ImgCompon = _this$props.ImgComponent,
          ImgComponent = _this$props$ImgCompon === void 0 ? _img_component["default"] : _this$props$ImgCompon;
      var _data$img = data.img,
          img = _data$img === void 0 ? '' : _data$img,
          time = data.time,
          _data$description = data.description,
          description = _data$description === void 0 ? '' : _data$description,
          dataTitle = data.title,
          imgAlt = data.imgAlt;

      var _getTheContentOfTheIt = (0, _index.getTheContentOfTheItemComponent)(_objectSpread({}, this.props, {
        disabled: data.disabled || false
      })),
          label = _getTheContentOfTheIt.label,
          className = _getTheContentOfTheIt.className,
          labelDom = _getTheContentOfTheIt.labelDom,
          onClick = _getTheContentOfTheIt.onClick,
          checked = _getTheContentOfTheIt.checked;

      var liProps = _objectSpread({}, (0, _index.getDataSet)(data));

      var title = '';

      if (!open) {
        return null;
      }

      if (changeTriggerEvent) {
        liProps[changeTriggerEvent] = onClick;
      }

      if (titleable) {
        if (customTitle) {
          title = dataTitle;
        } else if (typeof label === 'string' || typeof label === 'number') {
          title = label;
        }
      }

      var labelNode = null;

      if (typeof time === 'undefined') {
        if (showSelectionImgItemComponent && description) {
          labelNode = _react["default"].createElement("p", null, _react["default"].createElement("span", {
            className: "spaui-selection-item tt"
          }, labelDom), _react["default"].createElement("span", {
            className: "spaui-selection-item-desc tt-description",
            title: typeof description === 'string' ? description : ''
          }, description));
        } else {
          labelNode = _react["default"].createElement("p", null, labelDom);
        }
      } else {
        labelNode = _react["default"].createElement("p", {
          title: "".concat(label, " ").concat(time)
        }, labelDom, _react["default"].createElement("span", {
          className: "time"
        }, time));
      }

      return _react["default"].createElement("li", _extends({
        className: (0, _classnames["default"])(className, {
          'selection-without-icon': !img
        }),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver
      }, liProps, {
        "data-index": this.props['data-index']
      }), _react["default"].createElement("div", {
        className: "selection-content"
      }, multiple && _react["default"].createElement(_spauiCheckbox["default"], {
        checked: checked
      }), img ? _react["default"].createElement(ImgComponent, {
        img: img,
        imgAlt: imgAlt,
        className: "selection-icon",
        data: data,
        itemIndex: this.props['data-index']
      }) : null), _react["default"].createElement("div", _extends({
        className: "selection-name",
        title: title,
        "data-value": data.value
      }, (0, _index.getDataSet)(this.props)), labelNode));
    }
  }]);

  return SelectionImgItemComponent;
}(_react["default"].PureComponent);

var _default = SelectionImgItemComponent;
exports["default"] = _default;